import APITemplate from '@api/APITemplate'
import { diffTimeMinutes } from '@utils/Format'
import store from '@state/store'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'
import con from '@services/connection'
import { benchmarks } from '@modules/settings/constants/URL'

class APISettingsBenchmarks extends APITemplate {
  constructor() {
    super()

    this.reqCarregar = null
  }

  _formatData(items) {
    return items.map((item) => {
      return {
        ...item,
        _composition: item._composition
          ? item._composition.map((comp) => {
              return {
                ...comp,
                taxa: comp.taxa * 100,
              }
            })
          : item._composition,
      }
    })
  }

  _formatOrder(items) {
    return items.sort((a, b) => {
      if (b.indexador === 'PREFIXADO') {
        return -1
      }
      if (a.indexador === 'PREFIXADO') {
        return 1
      }
      return b.taxa - a.taxa
    })
  }

  async carregar(forceUpdate = false) {
    if (this.reqCarregar) {
      return this.reqCarregar
    }
    if (!forceUpdate) {
      if (
        !diffTimeMinutes(
          store.getters['settings/benchmarksLastUpdate'],
          MINUTES_TIMEOUT_REQUESTS
        )
      ) {
        return store.getters['settings/benchmarks']
      }
    }

    if (store.getters['settings/benchmarksLoading']) {
      return store.getters['settings/benchmarks']
    }

    store.dispatch('settings/setBenchmarksLoading', true)

    this.reqCarregar = con.get(benchmarks.list)
    const r = await this.reqCarregar

    if (r && r.status === 200) {
      const items = this._formatData(r.value || [])
      store.dispatch('settings/setBenchmarks', items)
    } else {
      store.dispatch('settings/setBenchmarks', [])
    }

    store.dispatch('settings/setBenchmarksLoading', false)

    this.reqCarregar = null

    return r || {}
  }

  async salvar({ id, composicao = [] }) {
    const dado = this._formatOrder(
      composicao.map((item, index) => {
        return {
          ...item,
          ordem: index + 1,
          taxa: Math.round10(item.taxa / 100, -4),
        }
      })
    )

    const data = {
      data: JSON.stringify(dado),
    }

    let r
    if (id) {
      r = await con.put(benchmarks.list + `/${id}`, data)
    } else {
      r = await con.post(benchmarks.list, data)
    }

    if (r && r.status === 200) {
      store.dispatch('settings/addBenchmarks', r.value[0] || r.value || {})
    }

    return r || {}
  }

  async remover({ id }) {
    if (!id) {
      return {
        status: 404,
        message: 'Item não encontrado.',
      }
    }

    store.dispatch('settings/setBenchmarksLoading', true)

    const r = await con.delet(benchmarks.list + `/${id}`)

    store.dispatch('settings/setBenchmarksLoading', false)

    if (r && r.status === 200) {
      this.carregar(true)
    }

    return r || {}
  }
}

const apiSettingsBenchmarks = new APISettingsBenchmarks()
export { apiSettingsBenchmarks }
